import React from 'react';
import { UploadItemCard } from './UploadItemCard';

export function UploadListSection({
  items,
  panelStyle,
  interactionLocked,
  isUploadBlockedByCaseStatus,
  transcriptAccept,
  getMediaSizeText,
  getPresentation,
  onDescriptionChange,
  onMediaDelete,
  onTranscriptToggle,
  onTranscriptFileChange,
  onBrowseTranscript,
  onTranscriptDescriptionChange,
  onTranscriptDelete,
  setTranscriptInputRef,
  renderDebug
}) {
  if (!items || items.length <= 0) {
    return null;
  }

  return (
    <div className="upload-list-shell" style={panelStyle}>
      {renderDebug ? renderDebug(items) : null}
      {items.map((item) => (
        <UploadItemCard
          key={item.id}
          item={item}
          mediaSizeText={getMediaSizeText(item)}
          interactionLocked={interactionLocked}
          isUploadBlockedByCaseStatus={isUploadBlockedByCaseStatus}
          transcriptAccept={transcriptAccept}
          presentation={getPresentation(item)}
          onDescriptionChange={onDescriptionChange}
          onMediaDelete={onMediaDelete}
          onTranscriptToggle={onTranscriptToggle}
          onTranscriptFileChange={onTranscriptFileChange}
          onBrowseTranscript={() => onBrowseTranscript(item)}
          onTranscriptDescriptionChange={onTranscriptDescriptionChange}
          onTranscriptDelete={onTranscriptDelete}
          setTranscriptInputRef={(element) => setTranscriptInputRef(item, element)}
        />
      ))}
    </div>
  );
}
